// import coblogo from "../assets/img/Vertical logo white.png";
import logpic from "../assets/img/Loginpic.png";
// import cloud from "../assets/img/upload-cloud.png";
import { hostName } from "../config/config";
import {
  // UPLOAD_CLIENT_UPLOADCLIENTBRANDING,
  // CHECK_SUBDOMAIN_NAME,
  UPDATE_CLIENT_BRANDING_DETAILS,
  GET_CLIENT_BRANDING_DETAILS,
} from "../api/apiPath";
import useGetClientId from "../hooks/useGetClientId";
import { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams, generatePath } from "react-router-dom";

import Header from "./Header";
import SidebarIcons from "./SidebarIcons";
import Sidebar from "./Sidebar";
import Toaster from "./common/Toaster";
import http from "../api/server";
import imageCompression from "browser-image-compression";

const ClientBranding = () => {
  const { clientNameParam } = useParams();
  const [portalName, setPortalName] = useState("");
  const [logoPreview, setLogoPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(false);
  const [subdomainMessage, setSubdomainMessage] = useState(null);
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const { userObj } = useSelector((state) => state.user);
  const [logoFile, setLogoFile] = useState(null);
  const [hideSidebar, setHideSidebar] = useState(false);
  const [summary, setSummary] = useState({});

  const clientObj = useGetClientId();
  const [clientLogo, setClientLogo] = useState("");
  const ImageProxyBaseUrl = hostName + "/api/Inspection/api/image?blobUrl=";

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  useEffect(() => {
    if (!userObj || !userObj?.token) {
      navigate(
        generatePath("/client/:clientNameParam", {
          clientNameParam,
        }),
        { replace: true, state: { from: "/ClientBranding" } }
      );
    }
  }, [userObj, navigate]);

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (file.size > 4 * 1024 * 1024) {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: "File size exceeds 4MB limit. Please choose a smaller file.",
        })
        e.target.value = null; // Clear the input
        return;
      }else{
        setLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));

      }
    }
  };

  useEffect(() => {
    if(clientObj.clientId && loading === false){
      setChecking(false); setSubdomainMessage(null);
      const fetchBrandingDetails = async () => {
        try {
          const response = await http.get(
            GET_CLIENT_BRANDING_DETAILS + "?ClientId=" + clientObj.clientId
          );
          if (response?.status === 200) {
            console.log("Branding details:", response.data);
            const data = response?.data?.clientDetails;
            setClientLogo(data?.clientLogoUrl || "");
            setPortalName(data?.clientSubDomainName || "");
            setSummary({
              subdomain: data?.clientSubDomain || "",
              available: true,
            });
          }
        } catch (err) {
          console.error("Error fetching branding details:", err);
        }
      };
      fetchBrandingDetails();
    }
  }, [userObj, clientObj.clientId, clientObj.loading, loading]);

  // useEffect(() => {
  //   const checkSubdomain = async () => {
  //     if (!portalName.trim()) {
  //       setSubdomainMessage(null);
  //       return;
  //     }

  //     const subdomain = portalName.replace(/\s+/g, "").toLowerCase();
  //     setChecking(true);
  //     try {
  //       const response = await fetch(
  //         `${hostName}${CHECK_SUBDOMAIN_NAME}?subdomain=${subdomain}`,
  //         {
  //           headers: {
  //             Authorization: "Bearer " + userObj?.token,
  //           },
  //         }
  //       );

  //       const data = await response.json();
  //       setSummary(data);
  //       // 🔹 Example response:
  //       // { available: false, suggestions: ["abc1", "abc2", "abc3"] }

  //       if (data?.available === false) {
  //         setSubdomainMessage({
  //           type: "error",
  //           suggestions: data?.suggestions || [],
  //         });
  //       } else {
  //         setSubdomainMessage({ type: "success" });
  //       }
  //     } catch (err) {
  //       console.error("Error checking subdomain:", err);
  //       setSubdomainMessage(null);
  //     } finally {
  //       setChecking(false);
  //     }
  //   };

  //   const delayDebounce = setTimeout(checkSubdomain, 600); // debounce
  //   return () => clearTimeout(delayDebounce);
  // }, [portalName, userObj]);

  const handleContinue = async () => {
    if (!logoFile || !portalName.trim()) return;

    setLoading(true);
    try {
      // const cleanSubdomain = portalName.replace(/\s+/g, "").toLowerCase();
      // const fullUrl = summary.subdomain;
      const options = {
        maxSizeMB: 0.5,              // Target size
        maxWidthOrHeight: 1024,      // Optional resize
        useWebWorker: true,
        initialQuality: 0.7,         // Start compression at 70%  
      };
      const compressedFile = await imageCompression(logoFile, options);
      const compreedFile = new File([compressedFile], logoFile.name, {
        type: logoFile.type,
      });
      const formData = new FormData();
      // const compressedBlob = await compressImage(logoFile);
      
      formData.append("ClientLogo", compreedFile);
      // formData.append("ClientSubDomain", fullUrl);
      formData.append("ClientSubDomainName", portalName);
      formData.append("clientEmail", userObj?.userEmail);

      const response = await fetch(hostName + UPDATE_CLIENT_BRANDING_DETAILS, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: "Bearer " + userObj?.token,
        },
      });

      console.log("API Response:", response);
      if (response?.status === 200) {
        setTimeout(() => {
          setToastData({
            toastShow: true,
            toastType: "success",
            toastString: "Client branding updated successfully.",
          });
        }, 1000);
      }
    } catch (err) {
      console.error("Error:", err);
      setTimeout(() => {
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString:  "An error occurred. Please try again.",
        });
      }, 1000);
    } finally {
      setLoading(false);
    }
  };

  // const compressImage = (file) =>
  // new Promise((resolve) => {
  //   const img = new Image();
  //   const reader = new FileReader();

  //   reader.onload = (e) => {
  //     img.src = e.target.result;
  //   };

  //   img.onload = () => {
  //     const canvas = document.createElement("canvas");
  //     const ctx = canvas.getContext("2d");

  //     canvas.width = img.width;
  //     canvas.height = img.height;
  //     ctx.drawImage(img, 0, 0);

  //     canvas.toBlob(
  //       (blob) => {
  //         resolve(blob);
  //       },
  //       logoFile.type,
  //       0.5 // compression quality (0–1)
  //     );
  //   };

  //   reader.readAsDataURL(file);
  // });

  return (
    <>
      <div>
        <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />
      </div>
      {userObj && (
        <div
          className="dashboard_body_main vh-100 d-flex flex-row py-0 pe-0"
          style={{ top: "0" }}
        >
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}
          <div className="login-form-section d-flex flex-column justify-content-center align-items-center">
            {/* <div className="login-form-wrapper">
              <img src={coblogo} alt="logo" className="login-logo" />
            </div> */}

            <div className="card-body px-5 pb-3" style={{alignContent: 'center'}}>
              <div className="col-sm-12  mb-4">
                <p className="personalName" style={{fontSize:'28px', textAlign:'justify'}}>Client Branding</p>
              </div>

              {/* Upload Section */}
              <div className="mt-3 text-start">
                <label className="form-label personalName">Logo</label>
              </div>
              <div className="upload-section d-flex align-items-center">
                <div className="upload-box" onClick={handleClick}>
                  <div className="upload-content">
                    {logoPreview ? (
                      <>
                        <img
                          src={logoPreview}
                          alt="Uploaded Logo"
                          className="uploaded-logo"
                        />
                      </>
                    ) : (
                      <img
                        style={{ height: "100px", width: "100px" }}
                        src={ImageProxyBaseUrl + encodeURIComponent(clientLogo)}
                        alt="upload"
                      />
                    )}
                  </div>
                </div>
                <div className="upload-info ms-3">
                  <p className="upload-text">
                    Drag & drop your file here or{" "}
                    <span className="browse-link" onClick={handleClick}>
                      click to browse
                    </span>
                  </p>
                  <small className="upload-hint">PNG, JPG up to 4MB</small>
                </div>
                {logoPreview && (
                  <p
                    style={{
                      color: "green",
                      marginTop: "80px",
                      fontSize: "14px",
                      marginLeft: "-280px",
                    }}
                  >
                    Image uploaded successfully
                  </p>
                )}
                <input
                  type="file"
                  accept="image/png, image/jpeg"
                  style={{ display: "none" }}
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  max={4}
                />
              </div>
              <div className="text-start">
                <p className="remark-text">
                  <span style={{ color: "red" }}>*</span> Logo will be used in
                  all reports and communication. Logo can be changed in the
                  settings.
                </p>
              </div>

              {/* Portal Name */}
              <div className="mb-3 mt-3 text-start">
                <label className="form-label personalName">
                  Client Portal Name
                </label>
                <input
                  type="text"
                  className="form-controlinputbox portal-input text-start"
                  style={{ width: "100%" }}
                  disabled
                  value={portalName}
                  onChange={(e) => setPortalName(e.target.value)}
                />

                {checking && (
                  <small className="text-info">Checking availability...</small>
                )}

                {!checking && subdomainMessage?.type === "success" && (
                  <small className="text-success">Subdomain available</small>
                )}

                {!checking && subdomainMessage?.type === "error" && (
                  <div>
                    <small className="text-danger d-block mb-1">
                      Subdomain already taken.
                    </small>
                    {subdomainMessage.suggestions?.length > 0 && (
                      <small
                        className="text-success"
                        style={{ color: "greenyellow" }}
                      >
                        Suggested alternatives:{" "}
                        {subdomainMessage.suggestions.join(", ")}
                      </small>
                    )}
                  </div>
                )}
              </div>

              {/* Portal URL */}
              <div className="mb-4 text-start">
                <label className="form-label personalName">
                  Client Portal Url(s)
                </label>
                <div className="genurl">
                  <span style={{ margin: "10px" }}>
                    {summary?.available ? (
                      <span>{summary?.subdomain}</span>
                    ) : (
                      summary?.suggestionUrls?.map((url, index) => (
                        <span key={index}>
                          {url}
                          <br />
                        </span>
                      ))
                    )}
                  </span>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-continue personalName w-100"
                    onClick={handleContinue}
                    disabled={loading || !logoFile || portalName.trim() === ""}
                  >
                    {loading ? "Please Wait..." : "Continue"}
                  </button>
                </div>
              </div>
            </div>

            {/* <p className="footertextotp personalName mt-5">
              By continuing, you agree to our Terms of Service and Privacy
              Policy
            </p> */}
          </div>
          <div className="login-image-section">
            <img
              src={logpic}
              alt="login-illustration"
              className="login-side-image"
            />
          </div>
        </div>
      )}
    </>
  );
};

export default ClientBranding;
